export const frontend = [
    {
        id: 1,
        value : "Android App Development with Java or Kotlin"
    },
    {
        id: 2,
        value : "React Website"
    },
    {
        id: 3,
        value : "Cross Platform Flutter Application"
    },
    {
        id: 4,
        value : "Responsive Website using HTML/CSS/JavaScript"
    }
]

export const backend = [
    {
        id: 1,
        value : "Secure & Scalable Spring Boot Application"
    },
    {
        id: 2,
        value : "Node JS Application"
    },
    {
        id: 3,
        value : "Intergration and Management of Databases like MongoDB, MySQL"
    }
]